import React from "react"
import { useDispatch } from "react-redux"

import { InputAdornment, List, ListItem, ListItemButton, ListItemText, TextField } from "@mui/material"
import { BiSearch } from "react-icons/bi"

import { ColumnTypeEnum } from "@/codegen/graphql-request"
import { useReferenceRecords } from "@/slice/masterRecordsSlice"
import { uiSlice } from "@/slice/uiSlice"
import { ReferenceConfig, ReferenceItem } from "@/type"

export const ReferenceItemPicker = (props: {
	reference: ReferenceConfig
	columnType: ColumnTypeEnum
	setInputValue: React.Dispatch<React.SetStateAction<string>>
}) => {
	const { reference, columnType, setInputValue } = props

	// List 型の場合は複数選択させる
	if (columnType == ColumnTypeEnum.List) {
		return (
			<Picker
				referenceConfig={reference}
				onSelect={(selectItem: ReferenceItem) => {
					setInputValue((prev) => {
						const newValues = prev
							.replace(/^\[|\]$/g, "")
							.split(",")
							.filter((v) => v)
						newValues.push(`"${selectItem.pkData}"`)
						return `[${newValues.join(",")}]`
					})
				}}
				closeOnSelect={false}
			/>
		)
	} else {
		return (
			<Picker
				referenceConfig={reference}
				onSelect={(selectItem: ReferenceItem) => setInputValue(selectItem.pkData)}
				closeOnSelect={true}
			/>
		)
	}
}

const Picker = (props: {
	referenceConfig: ReferenceConfig
	closeOnSelect: boolean
	onSelect: (selectItem: ReferenceItem) => void
}) => {
	const { referenceConfig, closeOnSelect } = props

	const dispatch = useDispatch()

	const referenceRecords = useReferenceRecords(referenceConfig)
	const [filter, setFilter] = React.useState("")
	const filteredReferenceItems = React.useMemo(() => {
		if (!referenceRecords) return []
		return referenceRecords.filter((i) => {
			if (filter) {
				return i.displayData.match(filter)
			} else {
				return true
			}
		})
	}, [filter, referenceRecords])

	const onSelectItem = (ev: React.MouseEvent, data: ReferenceItem) => {
		props.onSelect(data)
		if (closeOnSelect === false) {
			ev.stopPropagation()
			ev.preventDefault()
		}
	}

	return (
		<List aria-label="reference picker" sx={{ maxHeight: "50vh" }}>
			<ListItem>
				<TextField
					type="search"
					variant="standard"
					onMouseDown={() => {
						dispatch(uiSlice.actions.setContinueEditMode(true))
					}}
					onBlur={() => {
						dispatch(uiSlice.actions.setContinueEditMode(false))
					}}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<BiSearch />
							</InputAdornment>
						),
					}}
					placeholder="検索"
					value={filter}
					onChange={(ev) => setFilter(ev.target.value)}
				/>
			</ListItem>
			{filteredReferenceItems.map((data) => (
				<ListItem disablePadding key={data.recordId} data-testid="reference picker item">
					{/* ここ onClick が効かないので調査 */}
					<ListItemButton onMouseDown={(ev) => onSelectItem(ev, data)}>
						<ListItemText
							primary={data.displayData}
							sx={{
								whiteSpace: "nowrap",
							}}
						/>
					</ListItemButton>
				</ListItem>
			))}
		</List>
	)
}
